import { ReactComponent as IconConfigure } from "@/assets/svgs/red-info-icon.svg";
import { ReactComponent as IconIndicator } from '@/assets/svgs/indicator.svg';
import { ReactComponent as IconDownArrow } from '@/assets/svgs/caret-down.svg'
import { ReactComponent as IconChevronRight } from "@/assets/svgs/chevron-right.svg";
import { ReactComponent as WarningIndicator } from '@/assets/svgs/verification-inidicator.svg';
import Button from '@/components/Button/index';
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import Popover from '@/components/Popover/index';
import { MAKER_CHECKER_ETR_MODAL_CONTENT, MAKER_CHECKER_ETR_MODAL_CONTENT_V5, etrActionable, etrActions } from '@/constants/etr/etr-action/index';
import useModal from "@/hooks/use-modal/index";
import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import { feature } from "@/utils/feature-verifier.js";
import { featureConstant } from "@/constants/configuration/feature.js";
import RemarksComponent from "@/pages/record-transfer/etr-issuance/record-details/components/remarks-component";

const ActionableButton = ({ etrDocDetails, checkAction, setAction, hasNominatedBeneficiary, handleNominateNSurrender, handleRejectTransfers, isEditRequest, setIsEditRequest, setRemarksForTransfer }) => {
	const [filterVisible, setFilterVisible] = useState(false)
	const referenceRef = useRef(null)
	const [secondaryMenu, setSecondaryMenu] = useState(false);
	const [rejectAction, setRejectAction] = useState(null);
	const [modalType, setModalType] = useState(null)

	const { profile } = useSelector(state => state.auth);
	const isETRIGPNITRV5FeatureEnabled = feature(featureConstant?.ETR_IGPNI_TR_V5);
	const [remarks, setRemarks] = useState("");

	/*=================================================
		Popover
	/================================================*/

	useEffect(() => {
		document.addEventListener('mousedown', handleDocumentClick)
		return () => {
			document.removeEventListener('mousedown', handleDocumentClick)
		}
	}, [])

	function handleDocumentClick(event) {
		if (!referenceRef.current) {
			return
		}

		if (referenceRef.current.contains(event.target)) {
			return
		}

		setFilterVisible(false)
		setSecondaryMenu(false)
	}

	function handleManageAsset() {
		setFilterVisible(!filterVisible)
		setSecondaryMenu(false)
	}

	const shouldDisableForMakerChecker = (profile, etrDocDetails) => {
		const { organization, makerCheckerRole } = profile || {};
		const { makerChecker } = organization || {};

		if (makerChecker && makerCheckerRole === 'MAKER') return true;
		return !makerChecker && etrDocDetails?.eventStatus !== "NOMINATED";
	};

	function isButtonDisabled(profile, etrDocDetails) {
		const disabledStatuses = new Set([
			"OWNER_TRANSFERRING",
			"HOLDER_TRANSFERRING",
			"OWNER_HOLDER_TRANSFERRING",
			"NOMINATING",
			"OWNER_TRANSFER_PENDING_APPROVAL",
			"HOLDER_TRANSFER_PENDING_APPROVAL",
			"OWNER_HOLDER_TRANSFER_PENDING_APPROVAL",
			"NOMINATION_PENDING_APPROVAL",
			"SURRENDER_PENDING_APPROVAL",
			"OWNER_TRANSFER_APPROVED",
			"HOLDER_TRANSFER_APPROVED",
			"OWNER_HOLDER_TRANSFER_APPROVED",
			"NOMINATION_APPROVED",
			"ENDORSEMENT_PENDING_APPROVAL",
			"SURRENDERED",
			"ISSUANCE_APPROVED",
			"OWNER_HOLDER_TRANSFER_REJECTION_IN_PROGRESS",
			"OWNER_TRANSFER_REJECTION_IN_PROGRESS",
			"HOLDER_TRANSFER_REJECTION_IN_PROGRESS",
			"OWNER_TRANSFER_REJECTION_PENDING_APPROVAL",
			"HOLDER_TRANSFER_REJECTION_PENDING_APPROVAL",
			"OWNER_HOLDER_TRANSFER_REJECTION_PENDING_APPROVAL",
		]);
		if (shouldDisableForMakerChecker(profile, etrDocDetails)) {
			const status = etrDocDetails?.status;
			const eventStatus = etrDocDetails?.eventStatus;
			if (status === 'ISSUING') return true;
			if (status === 'SURRENDERING') return true;
			if (status === 'RESTORING') return true;
			if (status === 'SHREDDING') return true;
			if (disabledStatuses.has(eventStatus)) return true;
			return eventStatus === "NOMINATED" && checkAction === etrActions.ownerOnly;
		}
		return false;
	}

	const ActionButton = ({ ...props }) => {
		const disabled = isButtonDisabled(profile, etrDocDetails);
		if (checkAction === etrActions.ownerAndHolder || checkAction === etrActions.holderAndEndorseOwner || checkAction === etrActions.acceptRejectSurrender) {
			return (
				<><div
					data-testid='manage-asset-button'
					className={disabled ? 'etr-maker-checker__manage-asset_button-disabled' : 'etr-maker-checker__manage-asset_button'}
					onClick={() => handleManageAsset()}
					role='none'
				>
					<div>Manage Asset</div>
					<IconDownArrow />
				</div>
					{isEditRequest && (
						<Button
							text="Cancel"
							nohover
							noborder
							submit={() => setIsEditRequest(false)}
						/>
					)}
				</>)
		}
		if (checkAction === etrActions.ownerOnly) {
			return <>
				{!isETRIGPNITRV5FeatureEnabled ?
					<Button
						{...props}
						round={true}
						className="record-details-side-panel__actions__button"
						text="Transfer Ownership"
						disabled={disabled}
						submit={() => {
							setAction(etrActionable.transferOwner)
						}}
					/> : <div
						data-testid='manage-asset-button'
						className={disabled ? 'etr-maker-checker__manage-asset_button-disabled' : 'etr-maker-checker__manage-asset_button'}
						onClick={() => handleManageAsset()}
						role='none'
					>
						<div>Manage Asset</div>
						<IconDownArrow />
					</div>}
			</>
		}
		if (checkAction === etrActions.holderOnly) {
			return <>
				{!isETRIGPNITRV5FeatureEnabled ?
					<Button
						{...props}
						round={true}
						className="record-details-side-panel__actions__button"
						text="Transfer Holdership"
						disabled={disabled}
						submit={() => {
							setAction(etrActionable.transferHolder)
						}}
					/> : <div
						data-testid='manage-asset-button'
						className={disabled ? 'etr-maker-checker__manage-asset_button-disabled' : 'etr-maker-checker__manage-asset_button'}
						onClick={() => handleManageAsset()}
						role='none'
					>
						<div>Manage Asset</div>
						<IconDownArrow />
					</div>}
			</>
		}
		return (
			<></>
		)
	}

	function handleClick() {
		setFilterVisible(false)
		setSecondaryMenu(false)
		setRemarksForTransfer("")
	}

	const Menu = () => {
		const [mouseLeaveTimeout, setMouseLeaveTimeout] = useState(null);

		useEffect(() => {
			document.addEventListener('mousedown', handleDocumentClick)
			return () => {
				document.removeEventListener('mousedown', handleDocumentClick)
				if (mouseLeaveTimeout) {
					clearTimeout(mouseLeaveTimeout);
				}
			}
		}, [])

		const handleMouseEnter = () => {
			if (mouseLeaveTimeout) {
				clearTimeout(mouseLeaveTimeout);
				setMouseLeaveTimeout(null);
			}

			setSecondaryMenu(true);
		};

		const handleMouseLeave = () => {
			const timeoutId = setTimeout(() => {
				setSecondaryMenu(false);
			}, 1000);

			setMouseLeaveTimeout(timeoutId);
		};

		const handleSecondaryMouseEnter = () => {
			setSecondaryMenu(false);
		}

		function handleRejectOperations(action) {
			setRejectAction(action)
			handleClick()
			setRemarks("")
			setRemarksForTransfer("")
			showRejectTransferModal()
		}

		const ETRMakerCheckerActionable = () => {
			if (checkAction === etrActions.ownerAndHolder) {
				return (
					<div className='etr__menu__list etr-maker-checker__menu__list' ref={referenceRef}
						onMouseLeave={handleMouseLeave}
					>
						<div className='etr-maker-checker__menu__list__item' id='ownership_holdership' onMouseEnter={handleMouseEnter}>
							<Popover
								visible={secondaryMenu}
								options={{ modifiers: [{ name: 'offset', options: { offset: [-12, 16] } }] }}
								placement='left-start'
								display='block'
							>
								<Popover.Trigger>
									<div className='etr-maker-checker__transfer-button__actions'>
										<div className='etr-maker-checker__transfer-text'>Transfer</div>
										<IconChevronRight />
									</div>
								</Popover.Trigger>
								<Popover.Content>
									<div className='etr__menu__list etr-maker-checker__menu__list--secondary' onMouseEnter={handleMouseEnter}>
										<div className='etr-maker-checker__menu__list__secondary-items'
											onClick={() => {
												setAction(etrActionable.transferOwner)
												handleClick()
											}}
											role='none'
											onKeyDown={() => { }}
										>
											Ownership Only
										</div>
										<div className='etr-maker-checker__menu__list__secondary-items'
											onClick={() => {
												setAction(etrActionable.transferHolder)
												handleClick()
											}}
											role='none'
											onKeyDown={() => { }}
										>
											Holdership Only
										</div>
										<div className='etr-maker-checker__menu__list__secondary-items'
											onClick={() => {
												setAction(etrActionable.transferOwnerAndHolder)
												handleClick()
											}}
											role='none'
											onKeyDown={() => { }}
										>
											Ownership & Holdership
										</div>
									</div>
								</Popover.Content>
							</Popover>
						</div>
						{isETRIGPNITRV5FeatureEnabled && etrDocDetails?.isOwnerHolderRejectable && 
							<div className='etr-maker-checker__menu__list__item'
								onMouseEnter={handleSecondaryMouseEnter}
								onClick={() => handleRejectOperations(etrActionable.rejectTransferOwnerHolder)}
								role='none'
								onKeyDown={() => { }}
							>
								<div className="etr-maker-checker__transfer-text">
									{"Reject Ownership & Holdership"}
								</div>
							</div>
						}
						{hasNominatedBeneficiary && (
							<div
								className="etr-maker-checker__menu__list__item"
								onMouseEnter={handleSecondaryMouseEnter}
								onClick={() => {
									handleClick();
									setModalType('endorse');
									if (isEditRequest) {
										showEditRequestModal();
									} else {
										showModal(true);
									}
								}}
								role="none"
								onKeyDown={() => { }}
							>
								Endorse Ownership Transfer
							</div>
						)}

						<div className='etr-maker-checker__menu__list__item'
							onMouseEnter={handleSecondaryMouseEnter}
							onClick={() => {
								handleClick();
								setModalType('surrender');
								if (isEditRequest) {
									showEditRequestModal();
								} else {
									showModal(true);
								}
							}}
							role='none'
							onKeyDown={() => { }}
						>
							<div className="etr-maker-checker__transfer-text">
								{isETRIGPNITRV5FeatureEnabled ? "Surrender / Convert to Paper" : "Surrender Document"}
							</div>
						</div>
					</div>
				)
			}
			if (checkAction === etrActions.holderAndEndorseOwner) {
				return (
					<div className="etr__menu__list etr-maker-checker__menu__list">
						<div
							className="etr-maker-checker__menu__list__item"
							onClick={() => {
								setAction(etrActionable.transferHolder);
								handleClick();
							}}
							role='none'
						>
							Transfer Holdership
						</div>
						{isETRIGPNITRV5FeatureEnabled && etrDocDetails?.isHolderRejectable && (
							<div
								className="etr-maker-checker__menu__list__item"
								onClick={() => handleRejectOperations(etrActionable.rejectTransferHolder)}
								role='none'
							>
								Reject Holdership Transfer
							</div>
						)}
						<div
							className="etr-maker-checker__menu__list__item"
							onMouseEnter={handleSecondaryMouseEnter}
							onClick={() => {
								setModalType('endorse');
								handleClick();
								if (isEditRequest) {
									showEditRequestModal();
								} else {
									showModal(true);
								}
							}}
							role='none'
						>
							Endorse Ownership Transfer
						</div>
					</div>
				);
			}
			if (checkAction === etrActions.acceptRejectSurrender) {
				return (
					<div className='etr__menu__list etr-maker-checker__menu__list' ref={referenceRef}
						onMouseLeave={handleMouseLeave}
						role='none'
					>
						<div>
							<div className='etr-maker-checker__menu__list__item'
								onMouseEnter={handleSecondaryMouseEnter}
								onClick={() => {
									handleClick()
									showAcceptSurrenderModal(true)
								}}
								role='none'
							>
								{"Accept Surrender"}
							</div>
							<div className='etr-maker-checker__menu__list__item'
								onMouseEnter={handleSecondaryMouseEnter}
								onClick={() => {
									handleClick()
									showRejectSurrenderModal(true)
								}}
								role='none'
							>
								{"Reject Surrender"}
							</div>
						</div>
					</div>
				)
			}
			if (isETRIGPNITRV5FeatureEnabled && checkAction === etrActions.ownerOnly) {
				return (
					<div className="etr__menu__list etr-maker-checker__menu__list">
						<div
							className="etr-maker-checker__menu__list__item"
							role='none'
							onClick={() => {
								setAction(etrActionable.transferOwner)
							}}
						>
							Transfer Ownership
						</div>
						{
							etrDocDetails?.isOwnerRejectable && (
								<div
									className="etr-maker-checker__menu__list__item"
									role='none'
									onClick={() => {
										setRejectAction(etrActionable.rejectTransferOwner)
										setRemarks("")
										showRejectTransferModal()
									}}
								>
									Reject Ownership Transfer
								</div>
							)
						}

					</div>
				);
			}
			if (isETRIGPNITRV5FeatureEnabled && checkAction === etrActions.holderOnly) {
				return (
					<div className="etr__menu__list etr-maker-checker__menu__list">
						<div
							className="etr-maker-checker__menu__list__item"
							role='none'
							onClick={() => {
								setAction(etrActionable.transferHolder)
							}}
						>
							Transfer Holdership
						</div>
						{
							etrDocDetails?.isHolderRejectable && (
								<div
									className="etr-maker-checker__menu__list__item"
									role='none'
									onClick={() => {
										setRejectAction(etrActionable.rejectTransferHolder)
										showRejectTransferModal()
									}}
								>
									Reject Holdership Transfer
								</div>
							)
						}

					</div>
				);
			}
		}

		return (
			<Popover
				visible={filterVisible}
				options={{ modifiers: [{ name: 'offset', options: { offset: [0, 10] } }] }}
				display='block'
				placement='bottom-end'
			>
				<Popover.Trigger>
					<ActionButton />
				</Popover.Trigger>
				<Popover.Content>
					<ETRMakerCheckerActionable />
				</Popover.Content>
			</Popover>
		)
	}

	const renderModalHeaderAndContent = () => {
		let headerTitle = "";
		let bodyContent = "";
		const { ENDORSE_OWNERSHIP, SURRENDER } = isETRIGPNITRV5FeatureEnabled ? MAKER_CHECKER_ETR_MODAL_CONTENT_V5 : MAKER_CHECKER_ETR_MODAL_CONTENT;
		switch (modalType) {
			case "endorse":
				headerTitle = ENDORSE_OWNERSHIP.header;
				bodyContent = ENDORSE_OWNERSHIP.body;
				break;
			case "surrender":
				headerTitle = SURRENDER.header;
				bodyContent = SURRENDER.body;
				break;
			default:
				break;
		}

		return (
			<>
				{!isETRIGPNITRV5FeatureEnabled ? <CardConfigure.Header>
					<CardConfigure.Header.Icon>
						<IconIndicator />
					</CardConfigure.Header.Icon>
					<CardConfigure.Header.Title>
						{headerTitle}
					</CardConfigure.Header.Title>
				</CardConfigure.Header> :
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className="card-configure__approval-screen__icon">
											<IconConfigure />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											{headerTitle}
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>}
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div className="etr__modal__content">
							{bodyContent}
							{isETRIGPNITRV5FeatureEnabled && etrDocDetails?.tokenRegistryVersion === "V5" && <>
								<div className="etr__modal__content__space"></div>
								<RemarksComponent
									remarks={remarks}
									setRemarks={setRemarks}
									showTextArea={true}
									showLearnmore={false}
									showRemarksDivForTransfer={true}
									showRemarksInformation={true}
									showExtraRemarksInformation={modalType === "surrender" ? true : false}
								/>
							</>}
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
			</>
		);
	};

	const callActionApi = () => {
		switch (modalType) {
			case "endorse":
				setAction(etrActionable.endorseOwner);
				handleNominateNSurrender(etrActionable.endorseOwner, etrDocDetails?.tokenRegistryVersion, remarks);
				break;
			case "surrender":
				setAction(etrActionable.surrender);
				handleNominateNSurrender(etrActionable.surrender, etrDocDetails?.tokenRegistryVersion, remarks);
				break;
			default:
				break;
		}
	};

	/*=================================================
		Modal
	/================================================*/
	const { visible: acceptSurrenderModal, show: showAcceptSurrenderModal, hide: hideAcceptSurrenderModal } = useModal()
	const { visible: rejectSurrenderModal, show: showRejectSurrenderModal, hide: hideRejectSurrenderModal } = useModal()
	const { visible: rejectTransferModal, show: showRejectTransferModal, hide: hideRejectTransferModal } = useModal()
	const { visible: modal, show: showModal, hide: hideModal } = useModal();
	const { visible: confirmEditRequestModal, show: showEditRequestModal, hide: hideEditRequestModal } = useModal()

	return (
		<>
			<div className='etr__side-menu'>
				<Menu />
			</div>

			<Modal visible={rejectSurrenderModal} variant='small' close={hideRejectSurrenderModal}>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className="card-configure__approval-screen__icon">
											{isETRIGPNITRV5FeatureEnabled ? <IconConfigure /> : <IconIndicator />}
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											{"Reject Surrender"}
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className='etr__modal__content'>
								{!isETRIGPNITRV5FeatureEnabled ? "Reject surrender request of this transferable asset?" : <>
									<span>This action will revert the ETR to its active status.</span>
									{etrDocDetails?.tokenRegistryVersion === "V5" && <>
										<div className="etr__modal__content__space"></div>
										<RemarksComponent
											remarks={remarks}
											setRemarks={setRemarks}
											showTextArea={true}
											showLearnmore={false}
											showRemarksDivForTransfer={true}
											showRemarksInformation={true}
											showExtraRemarksInformation={false}
										/>
									</>}
								</>}
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Left>
							<Button
								addClass="etr-maker-checker__modal__cancel"
								text="Cancel"
								nohover
								noborder
								ghost
								submit={() => {
									hideRejectSurrenderModal()
								}}
							/>
						</CardConfigure.Footer.Left>
						<CardConfigure.Footer.Right>
							<Button
								text="Confirm"
								warning
								round
								submit={() => {
									hideRejectSurrenderModal()
									setAction(etrActionable.rejectSurrender)
									handleNominateNSurrender(etrActionable.rejectSurrender, etrDocDetails?.tokenRegistryVersion, remarks)
								}}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			<Modal visible={acceptSurrenderModal} variant='small' close={hideAcceptSurrenderModal}>
				<CardConfigure>
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className='card-configure__approval-screen__icon'>
											{isETRIGPNITRV5FeatureEnabled ? <IconConfigure /> : <IconIndicator />}
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											{"Accept Surrender"}
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							{!isETRIGPNITRV5FeatureEnabled ? <div className='etr__modal__content'>
								Accept surrender of this transferable asset?<br />You will not be able to undo this action.
							</div> : <div className='etr__modal__content'>
								<span>You are about to accept the return of an ETR, which will permanently invalidate it. Please confirm that you wish to proceed with this irreversible action.</span>
								{etrDocDetails?.tokenRegistryVersion === "V5" && <>
									<div className="etr__modal__content__space"></div>
									<RemarksComponent
										remarks={remarks}
										setRemarks={setRemarks}
										showTextArea={true}
										showLearnmore={false}
										showRemarksDivForTransfer={true}
										showRemarksInformation={true}
										showExtraRemarksInformation={false}
									/>
								</>}
							</div>
							}
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Left>
							<Button
								addClass="etr-maker-checker__modal__cancel"
								text="Cancel"
								nohover
								noborder
								ghost
								submit={() => {
									hideAcceptSurrenderModal()
								}}
							/>
						</CardConfigure.Footer.Left>
						<CardConfigure.Footer.Right>
							<Button
								text="Confirm"
								warning
								round
								submit={() => {
									hideAcceptSurrenderModal()
									setAction(etrActionable.acceptSurrender)
									handleNominateNSurrender(etrActionable.acceptSurrender, etrDocDetails?.tokenRegistryVersion, remarks)
								}}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			<Modal visible={modal} variant='small' close={() => {
				hideModal();
				handleClick();
				setModalType(null);
			}}>
				<CardConfigure>
					{renderModalHeaderAndContent()}
					<CardConfigure.Footer>
						<CardConfigure.Footer.Left>
							<Button
								addClass="etr-maker-checker__modal__cancel"
								text="Cancel"
								nohover
								noborder
								ghost
								submit={() => {
									hideModal();
									handleClick();
									setModalType(null);
								}}
							/>
						</CardConfigure.Footer.Left>
						<CardConfigure.Footer.Right>
							<Button
								warning
								noHover
								round
								text="Confirm"
								submit={() => {
									hideModal();
									callActionApi()
								}}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			<Modal visible={confirmEditRequestModal} variant='small' close={hideEditRequestModal}>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className={'card-configure__icon'}>
											<WarningIndicator />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Resubmit Request
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className='etr__modal__content'>Are you sure you want to resubmit the request ?</div>
							{isETRIGPNITRV5FeatureEnabled && (modalType === "endorse" || modalType === "surrender") && isEditRequest && etrDocDetails?.tokenRegistryVersion === "V5" && <>
									<div className="etr__modal__content__space"></div>
									<RemarksComponent
										remarks={remarks}
										setRemarks={setRemarks}
										showTextArea={true}
										showLearnmore={false}
										showRemarksDivForTransfer={true}
										showRemarksInformation={true}
										showExtraRemarksInformation={modalType === "surrender" ? true : false}
									/>
								</>
							}
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Left>
							<Button
								text="Cancel"
								ghost
								nohover
								noborder
								submit={() => {
									hideEditRequestModal()
								}}
								data-testid="cancel-edit-request"
							/>
						</CardConfigure.Footer.Left>
						<CardConfigure.Footer.Right>
							<Button
								text="Confirm"
								noHover
								round
								submit={() => {
									hideEditRequestModal()
									callActionApi()
								}}
								data-testid="confirm-edit-request"
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			<Modal visible={rejectTransferModal} variant='small' close={hideRejectTransferModal}>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className="card-configure__approval-screen__icon">
											<IconConfigure />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Record Transfer Rejection
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className='etr__modal__content'>
								<span>This action will revert who has control over the ETR. Ensure the previous owner and holder is informed and agree to this change.</span>
								{etrDocDetails?.tokenRegistryVersion === "V5" && <>
									<div className="etr__modal__content__space"></div>
									<RemarksComponent
										remarks={remarks}
										setRemarks={setRemarks}
										showTextArea={true}
										showLearnmore={false}
										showRemarksDivForTransfer={true}
										showRemarksInformation={true}
										showExtraRemarksInformation={false}
									/>
								</>}
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Left>
							<Button
								addClass="etr-maker-checker__modal__cancel"
								text="Cancel"
								nohover
								noborder
								ghost
								submit={() => { hideRejectTransferModal() }}
							/>
						</CardConfigure.Footer.Left>
						<CardConfigure.Footer.Right>
							<Button
								text="Confirm"
								warning
								round
								submit={() => {
									handleRejectTransfers(rejectAction, remarks)
									setFilterVisible(false)
									hideRejectTransferModal()
								}}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>
		</>
	);

}

ActionableButton.propTypes = {
	etrDocDetails: PropTypes.object,
	checkAction: PropTypes.string,
	setAction: PropTypes.func,
	hasNominatedBeneficiary: PropTypes.bool,
	handleNominateNSurrender: PropTypes.func,
	handleRejectTransfers: PropTypes.func,
	isEditRequest: PropTypes.bool,
	setIsEditRequest: PropTypes.func,
	setRemarksForTransfer: PropTypes.func
}

export default ActionableButton;
